import {
  useAuditorDashboardAuditJobs,
  useAuditorDashboardReviewJobs,
} from 'src/hooks/dashboard';
import { tryCall } from 'src/utils/core/functions';

export default () => {
  const {
    data: auditJobs,
    loading: auditJobsLoading,
    refetch: reFetchAuditJobs
  } = tryCall(() => useAuditorDashboardAuditJobs(), { data: [], loading: false });
  const {
    data: reviewJobs,
    loading: reviewJobsLoading,
    refetch: reFetchReviewJobs
  } = tryCall(() => useAuditorDashboardReviewJobs(), { data: [], loading: false });

  const reFetchNextAuditJobBatch = (offset) => {
    reFetchAuditJobs({ limit: 18, offset });
  };

  const reFetchNextReviewJobBatch = (offset) => {
    reFetchReviewJobs({ limit: 18, offset });
  };

  return {
    auditJobs: (auditJobs && auditJobs.auditorDashboardAuditJobs) || [],
    totalAuditJobs: (auditJobs && auditJobs.auditorDashboardAuditJobsPageInfo.totalCount) || 0,
    reFetchNextAuditJobBatch,
    reviewJobs: (reviewJobs && reviewJobs.auditorDashboardReviewJobs) || [],
    totalReviewJobs: (reviewJobs && reviewJobs.auditorDashboardReviewJobsPageInfo.totalCount) || 0,
    reFetchNextReviewJobBatch,
    auditJobsLoading,
    reviewJobsLoading,
  };
};
